import { IconNames } from '@blueprintjs/icons';
import { DateFormats, formatDate } from '@strata/helper-functions';
import { Icon } from '@strata/react-status-icons';
import { CountdownTimer } from '@strata/react-timers';
import dayjs from 'dayjs';

import { type IntakeCaseSummary } from 'store/api/intakeCaseApi';

interface IntakeCaseIssuesIconProps {
    intakeCase: IntakeCaseSummary;
    large?: boolean;
}

export const IntakeCasePausedIcon = ({ intakeCase, large = false }: IntakeCaseIssuesIconProps) => {
    if (!intakeCase.paused_at) {
        return null;
    }
    let icon;
    let intent;
    let tooltipContent;
    const baseContent = (
        <>
            <span className="sds_pause_icon__tooltip-header">
                <span className="font-semi-bold--uppercase">Snoozed</span>
                <CountdownTimer endTime={intakeCase.paused_at} hideStatus showTimePastEnded />
            </span>
            <div>{intakeCase.paused_reason}</div>
            <div>Snoozed on {formatDate(intakeCase.paused_at, DateFormats.DATE)}</div>
            <div>
                Ready for follow-up on {formatDate(intakeCase.reminder_date, DateFormats.DATE)}
            </div>
        </>
    );

    if (dayjs().isAfter(intakeCase.reminder_date)) {
        icon = IconNames.NOTIFICATIONS;
        intent = Icon.Intent.WARNING;
        tooltipContent = (
            <>
                <span className="sds_pause_icon__tooltip-header">
                    <Icon icon={IconNames.NOTIFICATIONS} />
                    <span className="font-semi-bold--uppercase">Reminder to resume</span>
                </span>
                {baseContent}
            </>
        );
    } else {
        icon = IconNames.NOTIFICATIONS_SNOOZE;
        intent = Icon.Intent.DEFAULT;
        tooltipContent = baseContent;
    }
    return (
        <Icon size={large ? 24 : 16} icon={icon} intent={intent} tooltipContent={tooltipContent} />
    );
};
